<label *ngIf="label" [for]="id" class="mb-2 global-form-field">{{ label | translate }} <span class="text-danger fw-bold" *ngIf="required">*</span></label>

<ng-container *ngIf="loading; else textareaTemplate">
    <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5px', height: '105px' }" />
</ng-container>

<ng-template #textareaTemplate>
  <textarea
      [id]="id"
      [name]="name"
      [(ngModel)]="value"
      [disabled]="disabled"
      [required]="required"
      [maxlength]="maxlength"
      [minlength]="minlength"
      [placeholder]="placeholder"
      (ngModelChange)="onChange($event)"
      class="form-control global-textarea"
      autocomplete="off"
      #inputModel="ngModel">
  </textarea>

  <div *ngIf="inputModel.invalid && inputModel.touched && inputModel.errors" class="error">
      <span *ngIf="inputModel.errors['required']">This field is required.</span>
      <span *ngIf="inputModel.errors['minlength']">Minimum length is {{ minlength }} characters.</span>
      <span *ngIf="inputModel.errors['maxlength']">Maximum length is {{ maxlength }} characters.</span>
  </div>
</ng-template>
